// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.gds.NamedDataSourceRecordReference
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSClass.vm

export class NamedDataSourceRecordReferenceBase {
  /** Do NOT invoke directly, instead use strongly typed createNamedDataSourceRecordReferenceBase factory method */
  constructor() {}

  // @ts-ignore: noUnusedLocals
  getJavaClass() {
    return "cawadg.NamedDataSourceRecordReference";
  }
  initFromJson(json, deserializeContext) {
    this.initNamedDataSourceRecordReference(json.dataSourceId != null ? json.dataSourceId : null, json.name != null ? json.name : null, json.recordId != null ? json.recordId : null);
  }
  initNamedDataSourceRecordReference(dataSourceId, name, recordId) {
    this._dataSourceId = dataSourceId;
    this._name = name;
    this._recordId = recordId;
  }
  toTSOG(result, serializeContext) {
    const retVal = result;
    if (this._dataSourceId != null) {
      retVal["dataSourceId"] = this._dataSourceId;
    }
    if (this._name != null) {
      retVal["name"] = this._name;
    }
    if (this._recordId != null) {
      retVal["recordId"] = this._recordId;
    }
    return retVal;
  }
  get dataSourceId() {
    return this._dataSourceId;
  }
  set dataSourceId(value) {
    this._dataSourceId = value;
  }
  get name() {
    return this._name;
  }
  set name(value) {
    this._name = value;
  }
  get recordId() {
    return this._recordId;
  }
  set recordId(value) {
    this._recordId = value;
  }
}
//# sourceMappingURL=NamedDataSourceRecordReferenceBase.js.map
